"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFeedbackDialogSlots = exports.default = exports.FeedbackDialog = void 0;
var _icons = require("@ori-ui/icons");
var _base = require("@ori-ui/mui-bundle/base");
var _material = require("@ori-ui/mui-bundle/material");
var _clsx = _interopRequireDefault(require("clsx"));
var _react = require("react");
var _DialogBase = require("../DialogBase");
var _utils = require("../utils");
var _feedbackDialogClasses = require("./feedbackDialogClasses");
var _jsxRuntime = require("react/jsx-runtime");
const getFeedbackDialogSlots = ownerState => {
  const {
    color,
    severity
  } = ownerState;
  return {
    root: ['root', `severity${(0, _utils.capitalize)(color ?? severity)}`],
    closeButton: ['closeButton'],
    dialogGrid: ['dialogGrid'],
    banner: ['banner'],
    content: ['content'],
    actions: ['actions'],
    header: ['header'],
    text: ['text']
  };
};
exports.getFeedbackDialogSlots = getFeedbackDialogSlots;
const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = getFeedbackDialogSlots(ownerState);
  const composedClasses = (0, _base.unstable_composeClasses)(slots, _feedbackDialogClasses.getFeedbackDialogUtilityClass, classes);
  return {
    ...classes,
    ...composedClasses
  };
};
const DialogRoot = (0, _material.styled)('div', {
  name: 'MuiOriFeedbackDialog',
  slot: 'Root',
  overridesResolver: ({
    ownerState
  }, styles) => [styles.root, styles[`severity${(0, _utils.capitalize)(ownerState.severity)}`]],
  shouldForwardProp: prop => (0, _utils.rootShouldForwardProp)(prop)
})(({
  theme
}) => ({
  position: 'fixed',
  zIndex: theme.zIndex.modal,
  right: 0,
  bottom: 0,
  top: 0,
  left: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  outline: 0,
  [theme.breakpoints.only('xs')]: {
    alignItems: 'flex-end'
  }
}));
const DialogBackdrop = (0, _material.styled)(_material.Backdrop, {
  name: 'MuiOriFeedbackDialog',
  slot: 'Backdrop',
  overridesResolver: (_, styles) => [styles.backdrop]
})({
  zIndex: -1
});
const DialogGrid = (0, _material.styled)(_material.ScopedCssBaseline, {
  name: 'MuiOriFeedbackDialog',
  slot: 'DialogGrid',
  overridesResolver: (_, styles) => [styles.dialogGrid],
  shouldForwardProp: prop => (0, _utils.shouldForwardProp)(prop)
})(({
  theme,
  ownerState
}) => ({
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.shape.largeComponentRadius,
  color: theme.palette.text.primary,
  boxShadow: theme.shadows[1],
  display: 'grid',
  gridTemplateAreas: `
        'banner'
        'content'`,
  gridTemplateRows: '70px auto',
  gridTemplateColumns: 'auto',
  justifyItems: 'stretch',
  position: 'relative',
  minWidth: 320,
  maxWidth: ownerState.maxWidth,
  ...(ownerState.fullWidth && {
    width: `calc(100% - ${_DialogBase.DEFAULT_DIALOG_PADDING})`
  }),
  minHeight: 100,
  maxHeight: `calc(100% - ${theme.spacing(32)})`,
  outline: 0,
  padding: 0,
  overflow: 'hidden',
  overflowY: 'auto',
  scrollbarGutter: 'auto',
  [theme.breakpoints.up('sm')]: {
    gridTemplateRows: '80px auto'
  },
  [theme.breakpoints.only('xs')]: {
    boxSizing: 'border-box',
    minWidth: '100vw',
    maxWidth: '100vw',
    width: '100vw',
    maxHeight: `calc(100% - ${theme.spacing(12)})`,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0
  }
}));
const Banner = (0, _material.styled)('div', {
  name: 'MuiOriFeedbackDialog',
  slot: 'Banner',
  skipSx: true,
  overridesResolver: (_, styles) => [styles.banner],
  shouldForwardProp: prop => (0, _utils.shouldForwardProp)(prop)
})(({
  theme,
  ownerState
}) => ({
  justifySelf: 'stretch',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '5rem',
  gridArea: 'banner'
}));
const Content = (0, _material.styled)('div', {
  name: 'MuiOriFeedbackDialog',
  slot: 'Content',
  skipSx: true,
  overridesResolver: (_, styles) => [styles.content],
  shouldForwardProp: prop => (0, _utils.shouldForwardProp)(prop)
})(({
  theme
}) => ({
  display: 'grid',
  gridArea: 'content',
  padding: theme.spacing(0, 3, 6, 3),
  rowGap: theme.spacing(2),
  justifyItems: 'center',
  gridTemplateAreas: `
        'header'
        'content'
        'actions'
      `,
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(0, 6, 6, 6)
  }
}));
const Header = (0, _material.styled)(_material.Typography, {
  name: 'MuiOriFeedbackDialog',
  slot: 'Header',
  skipSx: true,
  overridesResolver: (_, styles) => [styles.header],
  shouldForwardProp: prop => (0, _utils.shouldForwardProp)(prop)
})({
  gridArea: 'header',
  textAlign: 'center'
});
const Text = (0, _material.styled)(_material.Typography, {
  name: 'MuiOriFeedbackDialog',
  slot: 'Text',
  skipSx: true,
  overridesResolver: (_, styles) => [styles.text],
  shouldForwardProp: prop => (0, _utils.shouldForwardProp)(prop)
})({
  gridArea: 'content',
  textAlign: 'center'
});
const Actions = (0, _material.styled)('div', {
  name: 'MuiOriFeedbackDialog',
  slot: 'Actions',
  skipSx: true,
  overridesResolver: (_, styles) => [styles.actions],
  shouldForwardProp: prop => (0, _utils.shouldForwardProp)(prop)
})(({
  theme
}) => ({
  gridArea: 'actions',
  display: 'grid',
  justifySelf: 'stretch',
  justifyItems: 'center',
  rowGap: theme.spacing(3),
  marginTop: theme.spacing(6)
}));
const defaultIconMapping = {
  success: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.CheckCircleFilled, {
    fontSize: "inherit",
    color: "success"
  }),
  error: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.ErrorCircleFilled, {
    fontSize: "inherit",
    color: "error"
  }),
  info: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.InfoCircleFilled, {
    fontSize: "inherit",
    color: "info"
  }),
  warning: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.WarningFilled, {
    fontSize: "inherit",
    color: "default"
  })
};
const FeedbackDialog = exports.FeedbackDialog = /*#__PURE__*/(0, _react.forwardRef)((inProps, ref) => {
  const props = (0, _material.useThemeProps)({
    props: inProps,
    name: 'MuiOriFeedbackDialog'
  });
  const {
    actions,
    ariaDescribedby,
    ariaLabelledby,
    ariaModal = true,
    children = null,
    className,
    closeAfterTransition = true,
    closeButtonProps = {
      variant: 'outlined',
      color: 'secondary',
      size: 'small'
    },
    color,
    disableAutoFocus = false,
    disableEnforceFocus = false,
    disableEscapeKeyDown = false,
    disablePortal = true,
    disableRestoreFocus = false,
    disableScrollLock = false,
    header,
    hideBackdrop = false,
    hideCloseButton,
    iconMapping = defaultIconMapping,
    keepMounted = false,
    fullWidth = false,
    maxWidth = '60vw',
    open,
    severity = 'info',
    transitionProps,
    ...other
  } = props;
  const {
    onClose
  } = other;
  const commonProps = {
    closeAfterTransition,
    disableAutoFocus,
    disableEnforceFocus,
    disableEscapeKeyDown,
    disablePortal,
    disableRestoreFocus,
    disableScrollLock,
    hideBackdrop,
    keepMounted
  };
  const maxWidthCalculated = (0, _react.useMemo)(() => (0, _DialogBase.calculateMaxWidth)(maxWidth), [maxWidth]);
  const ownerState = (0, _react.useMemo)(() => ({
    ...props,
    color,
    fullWidth,
    maxWidth: maxWidthCalculated,
    severity
  }), [color, fullWidth, maxWidthCalculated, props, severity]);
  const classes = useUtilityClasses(ownerState);
  const internalIcon = (0, _react.useMemo)(() => iconMapping[severity], [severity, iconMapping]);
  const handleClose = (0, _react.useCallback)(event => {
    onClose?.(event ?? {}, 'escapeKeyDown');
  }, [onClose]);
  const showActions = (0, _react.useMemo)(() => {
    if (typeof actions === 'undefined' || actions === null) {
      return false;
    }
    return true;
  }, [actions]);
  const showHeader = (0, _react.useMemo)(() => {
    if (typeof header === 'undefined' || header === '') {
      return false;
    }
    return true;
  }, [header]);
  const showChildren = (0, _react.useMemo)(() => {
    if (typeof children === 'undefined' || children === null) {
      return false;
    }
    return true;
  }, [children]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_base.Modal, {
    slots: {
      root: DialogRoot,
      backdrop: DialogBackdrop
    },
    slotProps: {
      root: () => ({
        ownerState
      })
    },
    open: open,
    className: (0, _clsx.default)(classes.root, className),
    ...other,
    ref: ref,
    ...commonProps,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_DialogBase.Transition, {
      ...transitionProps,
      in: open,
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(DialogGrid, {
        ownerState: ownerState,
        className: classes.dialogGrid,
        role: "dialog",
        "aria-describedby": ariaDescribedby,
        "aria-labelledby": ariaLabelledby,
        "aria-modal": ariaModal,
        children: [!hideCloseButton && /*#__PURE__*/(0, _jsxRuntime.jsx)(_DialogBase.CloseButton, {
          ...closeButtonProps,
          className: classes.closeButton,
          handleClick: handleClose
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(Banner, {
          ownerState: ownerState,
          className: classes.banner,
          children: internalIcon
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(Content, {
          ownerState: ownerState,
          className: classes.content,
          children: [showHeader ? /*#__PURE__*/(0, _jsxRuntime.jsx)(Header, {
            ownerState: ownerState,
            variant: "h5",
            className: classes.header,
            children: header
          }) : null, showChildren ? /*#__PURE__*/(0, _jsxRuntime.jsx)(Text, {
            ownerState: ownerState,
            as: "div",
            className: classes.text,
            children: children
          }) : null, showActions ? /*#__PURE__*/(0, _jsxRuntime.jsx)(Actions, {
            ownerState: ownerState,
            className: classes.actions,
            children: actions
          }) : null]
        })]
      })
    })
  });
});
var _default = exports.default = FeedbackDialog;
